/** Options for a single line in an amCharts 5 tooltip label. */
export interface TooltipLineOptions {
	fontSize?: number;
	bold?: boolean;
	color?: string;
}

/**
 * Fluent builder for amCharts 5 tooltip labelText strings (styled with [tag]...[/] markup).
 */
export class TooltipLabelBuilder {
	private components: string[] = [];

	/**
	 * Add a line with optional styling. Placeholders like {valueY} or {valueX.formatDate("...")} are passed through.
	 */
	line(text: string, options?: TooltipLineOptions): this {
		const tags: string[] = [];
		if (options?.color) tags.push(options.color);
		if (options?.fontSize != null) tags.push(`fontSize: ${options.fontSize}px`);
		if (options?.bold) tags.push('bold');
		const open = tags.length ? `[${tags.join(' ')}]` : '';
		const close = tags.length ? '[/]' : '';
		this.components.push(`${open}${text}${close}`);
		return this;
	}

	build(): string {
		return this.components.join('\n');
	}
}
